var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileDir({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0312 6.88232V13.6323C16.0312 14.409 15.4017 15.0386 14.625 15.0386H3.375C2.59834 15.0386 1.96875 14.409 1.96875 13.6323V5.08232V4.63232C1.96875 3.85567 2.59834 3.22607 3.375 3.22607H6.38052C6.75348 3.22607 7.11117 3.37424 7.37489 3.63796L8.63638 4.89944C9.00559 5.26866 9.50635 5.47607 10.0285 5.47607H14.625C15.4017 5.47607 16.0312 6.10567 16.0312 6.88232Z",
    fill: "#EBEBEB",
    fillOpacity: 0.49,
    stroke: "#0D0D0D",
    strokeWidth: 1.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2960_6529)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3513 5.3916H11.2582C10.9958 5.3916 10.7822 5.59013 10.7822 5.83454V11.9987C10.7822 12.2435 10.9958 12.4416 11.2582 12.4416H15.3513C15.6137 12.4416 15.8273 12.2435 15.8273 11.9987V5.83454C15.8273 5.59013 15.6141 5.3916 15.3513 5.3916ZM14.0098 6.28543H13.5494V6.68513H14.0098V7.16778H13.5494V7.56748H14.0098V8.05013H13.5494V8.4569H14.0024V10.2423H12.6071V8.4569H13.0674L13.0601 7.60895H12.5997V7.12631H13.0601V6.7266H12.5997V6.24395H13.0601V5.80278H14.0093V6.28543H14.0098Z",
    fill: "#0D0D0D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5139 8.91162H13.0752V9.33206H13.5139V8.91162Z",
    fill: "#0D0D0D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2960_6529"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7.82609,
    height: 7.5,
    fill: "white",
    transform: "translate(9.3916 5.38232)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileDir);
export default __webpack_public_path__ + "static/media/fileDir.4242bb50bc64c4f841189b6d3edbcfff.svg";
export { ForwardRef as ReactComponent };